import {
  and,
  ControlProps,
  OwnPropsOfEnum,
  RankedTester,
  rankWith,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsOneOfEnumProps } from "@jsonforms/react";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";

const GroupViewRenderer = ({ data }: ControlProps & OwnPropsOfEnum) => {
  const services = { ...data.services };
  return (
    <>
      {Object.keys(services).map(service => {
        return (
          <FormDetailWrapper key={service} data-testid="form-content-item">
            <FormDetailItem>{service} :</FormDetailItem>
            <FormDetailValue>{data.services[service]}</FormDetailValue>
          </FormDetailWrapper>
        );
      })}
    </>
  );
};

export const groupViewTester: RankedTester = rankWith(
  25,
  and(uiTypeIs("Group")),
);

export default withJsonFormsOneOfEnumProps(GroupViewRenderer);
